export default "__VITE_ASSET__cGTp4cjV__"